import React from "react";
import Common from "./../../Common";
import Header from "./../../Header";

import { Link, Redirect } from "react-router-dom";
import PasswordUpdate from "./PasswordUpdate";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Message } from "../UI";

class AddUser extends Common {
  constructor(props) {
    super(props);
    var localdata = { ...this.getCommonData() };
    this.state = {
      isLoading: "data-loader",
      apiUrl: this.decryptconfigdata("apiUrl"),
      fields: {},
      formData: {},
      localdata: localdata,
      redirect: false,
      redirectTo: false,
      message: "",
      groupsList: [],
      selectedList: [],
      selectedGroupsList: [],
      // selectedRoleList: ' ',
      groupData: [],
      group_data: [],
      userRole: [],
      groupMembers: [],
      errors: {},
      initialValues: {
        username: "",
        email: "",
        company_name: "",
        password: "",
        mobile: "",
        confirm_password: "",
      },
      error: {},
      groups: [],
      permission: "",
      cardAvailability: [],
      showImage: "",
      update: 0,
      user_name: localStorage.getItem("user_name")
        ? localStorage.getItem("user_name")
        : "",
    };
    this.submitUser = this.submitUser.bind(this);
  }

  async componentWillMount() {
    // this.getCardList();
    let isLoggedin = await this.checklogion();

    var title = this.props.title ? this.props.title : "";
    document.title = `Tattle | ${title}`;
  }

  submitUser = (val) => {
    var formData = this.state.formData;

    let error = this.state.error;
    this.setState({
      error_message: "",
    });
    formData.userRole = this.state.selectedRoleList;
    formData.groups = this.state.selectedGroupsList;
    let api_url = this.state.apiUrl + "adduser";
    if (this.state.update != 0) {
      formData.id = this.isSet(this.props.update_profile)
        ? this.state.localdata.data.user_uuid
        : this.props.match.params.id;
      formData.userRole = this.state.selectedRoleList;
      api_url = this.state.apiUrl + "update";
    }
    this.state.fields["formData"] = { ...val };
    this.state.fields["token"] = this.state.localdata.access_token;
    this.state.fields["app_token"] = this.state.localdata.app_token;
    document.getElementById("add_user_btn").disabled = false;
    this.setState({
      isLoading: "data-loader",
    });
    this.setState({
      formData: formData,
    });
    fetch(api_url, {
      method: "POST",
      dataType: "json",
      body: JSON.stringify(this.state.fields),
    })
      .then((response) => response.json())
      .then((result) => {
        this.setState({
          isLoading: "data-loader-hide",
        });
        if (result.code === 200) {
          this.props.history.push("/tattle/users");
          if (this.props.update_profile === "1")
            if (
              !this.isSet(this.props.update_profile) ||
              this.isSet(this.props.update_profile)
            ) {
              this.props.history.push("/tattle/users");
            } else document.getElementById("add_user_btn").disabled = false;
          this.setState({
            error_message: "",
          });
        } else {
          this.setState({
            error_message: result.msg,
          });
          document.getElementById("add_user_btn").disabled = false;
        }
      });
    return false;
  };
  render() {
    const phoneRegExp =
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    const addUser = Yup.object({
      username: Yup.string()
        .min(3)
        .max(25)
        .required("Please enter your user name"),
      email: Yup.string().email().required("Please enter your email"),
      company_name: Yup.string().required("Company Name is required"),
      mobile: Yup.string()
        .matches(phoneRegExp, "Phone number is not valid")
        .required("Contact number is required"),
      password: this.state.update
        ? null
        : Yup.string().min(6).required("Please enter you password"),
      confirm_password: this.state.update
        ? null
        : Yup.string()
            .required()
            .oneOf([Yup.ref("password"), null], "Password must match"),
    });
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }
    // let base64ToString = Buffer.from(this.state.formData['profile_image'], "base64").toString()

    const { schema, Uischema, groupsList, group, userRole } = this.state;

    this.state.permission = false;
    return (
      <div class="mainContent-panel-wrap" style={{ overflow: "auto" }}>
        <Header
          brecum_name={{ name: this.props.title, link: "/tattle/users" }}
          brecum_page={"Users"}
        />
        <div class="content-wrapper">
          <div class="wrapper">
            <div class="page-content">
              <div className="clear clearfix"></div>
              <div className={this.state.isLoading}></div>
              <div class="row">
                <div class="col-sm-9">
                  <div class="card p-0">
                    <ul
                      class="nav nav-tabs _custom3 px-4 border-bottom"
                      id="myTab"
                      role="tablist"
                    >
                      {this.state.update > 0 ? (
                        this.props.update_profile === "1" ? (
                          <li class="nav-item">
                            <a
                              class="nav-link active cancel-account-open"
                              id="accountDetails"
                              data-bs-toggle="tab"
                              href="#account_details"
                              role="tab"
                              aria-controls="account_details"
                              aria-selected="true"
                            >
                              Account Details
                            </a>
                          </li>
                        ) : (
                          <li class="nav-item">
                            <a
                              class="nav-link active cancel-account-open"
                              id="accountDetails"
                              data-bs-toggle="tab"
                              href="#account_details"
                              role="tab"
                              aria-controls="account_details"
                              aria-selected="true"
                            >
                              Update User
                            </a>
                          </li>
                        )
                      ) : (
                        <li class="nav-item">
                          <a
                            class="nav-link active cancel-account-open"
                            id="accountDetails"
                            data-bs-toggle="tab"
                            href="#account_details"
                            role="tab"
                            aria-controls="account_details"
                            aria-selected="true"
                          >
                            Add User
                          </a>
                        </li>
                      )}

                      {this.props.update_profile === "1" ? (
                        <li class="nav-item">
                          <a
                            class="nav-link cancel-account-close"
                            id="changePassword"
                            data-bs-toggle="tab"
                            href="#change_password"
                            role="tab"
                            aria-controls="change_password"
                            aria-selected="false"
                          >
                            Change Password
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                    <div class="card-body p-4 m-2">
                      <div class="tab-content" id="myTabContent">
                        <div
                          class="tab-pane fade show active"
                          id="account_details"
                          role="account_details"
                          aria-labelledby="accountDetails"
                        >
                          {this.state.update > 0 ? (
                            this.props.update_profile === "1" ? (
                              <h1 class="title mb-3">Account Info</h1>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                          <div>
                            {this.state.error_message ? (
                              <Message
                                board={{
                                  board: true,
                                  message: this.state.error_message,
                                  position: "bottom-end",
                                  bg: "danger",
                                  title: "Error",
                                }}
                              />
                            ) : (
                              ""
                            )}
                            <div class="pb-3">
                              <div class="row">
                                <Formik
                                  enableReinitialize
                                  initialValues={this.state.initialValues}
                                  onSubmit={this.submitUser}
                                  validationSchema={addUser}
                                >
                                  {(formik) => {
                                    return (
                                      <Form>
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                          <div class="mb-3">
                                            <label class="form-label">
                                              Enter Name*
                                            </label>
                                            <input
                                              type="text"
                                              id="username"
                                              name="username"
                                              value={formik.values.username}
                                              onChange={formik.handleChange}
                                              class="form-control"
                                              autoComplete="off"
                                              onBlur={formik.handleBlur}
                                            />
                                            {formik.errors.username &&
                                            formik.touched.username ? (
                                              <div class="error">
                                                {formik.errors.username}
                                              </div>
                                            ) : null}
                                          </div>

                                          {this.state.update > 0 ? (
                                            this.props.update_profile ===
                                            "1" ? (
                                              <div>
                                                <div class="mb-3">
                                                  <label class="form-label">
                                                    Email*
                                                  </label>
                                                  <input
                                                    type="email"
                                                    name="email"
                                                    value={formik.values.email}
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    autoComplete="off"
                                                    // readOnly={true}
                                                    onBlur={formik.handleBlur}
                                                    class="form-control"
                                                  />
                                                  {formik.errors.email &&
                                                  formik.touched.email ? (
                                                    <span class="error">
                                                      {formik.errors.email}
                                                    </span>
                                                  ) : null}
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )
                                          ) : (
                                            <div>
                                              <div class="mb-3">
                                                <label class="form-label">
                                                  Email*
                                                </label>
                                                <input
                                                  type="email"
                                                  name="email"
                                                  value={formik.values.email}
                                                  onChange={formik.handleChange}
                                                  autoComplete="off"
                                                  // readOnly={true}
                                                  onBlur={formik.handleBlur}
                                                  class="form-control"
                                                />
                                                {formik.errors.email &&
                                                formik.touched.email ? (
                                                  <span class="error">
                                                    {formik.errors.email}
                                                  </span>
                                                ) : null}
                                              </div>
                                            </div>
                                          )}

                                          <div class="mb-3">
                                            <label class="form-label">
                                              Contact Number*
                                            </label>
                                            <input
                                              type="text"
                                              name="mobile"
                                              value={formik.values.mobile}
                                              onChange={formik.handleChange}
                                              autoComplete="off"
                                              // readOnly={true}
                                              onBlur={formik.handleBlur}
                                              class="form-control"
                                            />
                                            {formik.errors.mobile &&
                                            formik.touched.mobile ? (
                                              <span class="error">
                                                {formik.errors.mobile}
                                              </span>
                                            ) : null}
                                          </div>

                                          <div class="mb-3">
                                            <label class="form-label">
                                              Company Name*
                                            </label>
                                            <input
                                              type="text"
                                              name="company_name"
                                              value={formik.values.company_name}
                                              onChange={formik.handleChange}
                                              autoComplete="off"
                                              // readOnly={true}
                                              onBlur={formik.handleBlur}
                                              class="form-control"
                                            />
                                            {formik.errors.company_name &&
                                            formik.touched.company_name ? (
                                              <span class="error">
                                                {formik.errors.company_name}
                                              </span>
                                            ) : null}
                                          </div>

                                          {this.state.update > 0 ? (
                                            this.props.update_profile ===
                                            "1" ? (
                                              ""
                                            ) : (
                                              ""
                                            )
                                          ) : (
                                            <div>
                                              <div class="mb-3">
                                                <label class="form-label">
                                                  Password*
                                                </label>
                                                <input
                                                  type="password"
                                                  name="password"
                                                  class="form-control"
                                                  value={formik.values.password}
                                                  onChange={formik.handleChange}
                                                  autoComplete="off"
                                                  // readOnly={true}
                                                  onBlur={formik.handleBlur}
                                                />
                                                {formik.errors.password &&
                                                formik.touched.password ? (
                                                  <div class="error">
                                                    {formik.errors.password}
                                                  </div>
                                                ) : null}
                                              </div>
                                              <div class="mb-3">
                                                <label class="form-label">
                                                  Confirm Password*
                                                </label>
                                                <input
                                                  type="password"
                                                  name="confirm_password"
                                                  class="form-control"
                                                  value={
                                                    formik.values
                                                      .confirm_password
                                                  }
                                                  onChange={formik.handleChange}
                                                  autoComplete="off"
                                                  // readOnly={true}
                                                  onBlur={formik.handleBlur}
                                                />
                                                {formik.errors
                                                  .confirm_password &&
                                                formik.touched
                                                  .confirm_password ? (
                                                  <div class="error">
                                                    {
                                                      formik.errors
                                                        .confirm_password
                                                    }
                                                  </div>
                                                ) : null}
                                              </div>
                                              <div className="admin-radio">
                                                <span>
                                                  {" "}
                                                  <input
                                                    type="radio"
                                                    name="user_type"
                                                    value="1"
                                                    className="form-check-input"
                                                  />{" "}
                                                  Admin
                                                </span>
                                                <span>
                                                  {" "}
                                                  <input
                                                    type="radio"
                                                    name="user_type"
                                                    value="0"
                                                    checked
                                                    className="form-check-input"
                                                  />{" "}
                                                  User
                                                </span>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                        <div class="d-flex justify-content-start">
                                          <button
                                            style={{ marginTop: 20 }}
                                            type="submit"
                                            id="add_user_btn"
                                            class="muBtn _blue _minW"
                                          >
                                            {this.state.adding
                                              ? "Adding..."
                                              : this.state.update > 0
                                              ? this.props.update_profile ===
                                                "1"
                                                ? "Update Profile"
                                                : "Update User"
                                              : "Add User"}
                                          </button>
                                        </div>
                                      </Form>
                                    );
                                  }}
                                </Formik>
                              </div>
                            </div>
                          </div>
                        </div>
                        {this.props.update_profile === "1" ? (
                          <div
                            class="tab-pane fade"
                            id="change_password"
                            role="change_password"
                            aria-labelledby="changePassword"
                          >
                            <div>
                              <PasswordUpdate />
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddUser;
